import React,{createContext, useState} from 'react'
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import English from '../languages/English.json';
import French from '../languages/French.json';

const themeContext = createContext();
i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: English
      },
      fr: {
        translation: French
      },
    },
    lang: "en", // remove this during use of languge detector
    fallbackLng: "en", // Fallback language if translation is missing

    interpolation: {
      escapeValue: false
    }
  });

const Theme = (props) => {
    const [dark,setDark] = useState(true);
    const toggleTheme = () => setDark(!dark);
    const changeLang = (lang) => {
      i18n.changeLanguage(lang); //use to set diffrent language
    }

  return (
    <themeContext.Provider value={{dark, setDark, toggleTheme, changeLang}} >
        {props.children}
        </themeContext.Provider >
  )
}

export  {themeContext,Theme};